<template>
    <div>
      <viewer :images="list">
        <div v-for="(p,index) in list" :key="index" style="margin-top:1rem;">
            <div style="padding-left:7px;">{{getMsgTimeFormat(p.gdate)}}</div>
            <v-row style="margin:0;" >
                <v-col style="padding:6px;margin-top:0.29rem;" cols="4" v-for="(item,pindex) in p.plist" :key="pindex">
                  <div style="width:100px;height:100px;">
                    <img
                        :src="item.PICTURE_THUMB_URL"
                        :data-original="item.PICTURE_URL"
                        onError='this.src="/res/default_img.jpg";this.onerror=null;'
                        alt="A"
                        class="img-rounded"
                        style="width:100%;height:100%;border-radius:5px;border:1px solid #f2f2f2;"
                    />
                  </div>
                </v-col>
                <v-col style="padding:6px;margin-top:0.29rem;" v-if="index === list.length - 1 && waitPicture" cols="4">
                  <div style="width:100px;height:100px;">
                    <div style="width:100%;height:100%;border-radius:5px;background: #eee;">
                      <v-progress-circular color="#ffffff80" indeterminate style="width: 60px;height: 60px;margin-top: 20px;margin-left: 20px;"></v-progress-circular>
                    </div>
                  </div>
                </v-col>
                <v-col style="padding:5px;margin-top:0.2rem;" v-if="index === list.length - 1 " cols="4">
                    <TUploadPicture ref="uploadPicture" style="margin:0;padding:0;" v-if="hasUploadIcon" :showPicture="false" @uploadComplete="uploadAppendComp" @waitComplete="waitState" />
                </v-col>
            </v-row>
        </div>
      </viewer>
      <div v-if="list.length === 0">
          <!-- <TUploadPicture ref="uploadPicture" style="margin:0;padding:0;" v-if="hasUploadIcon" :showPicture="false" @uploadComplete="uploadAppendComp" /> -->
          <v-row>
            <v-col style="padding:6px;margin-top:0.29rem;" v-if="waitPicture" cols="4">
              <div style="width:100px;height:100px;">
                <div style="width:100%;height:100%;border-radius:5px;background: #eee;">
                  <v-progress-circular color="#ffffff80" indeterminate style="width: 60px;height: 60px;margin-top: 20px;margin-left: 20px;"></v-progress-circular>
                </div>
              </div>
            </v-col>
            <v-col style="padding:5px;margin-top:0.2rem;" cols="4">
                <TUploadPicture ref="uploadPicture" style="margin:0;padding:0;" v-if="hasUploadIcon" :showPicture="false" @uploadComplete="uploadAppendComp" @waitComplete="waitState" />
            </v-col>
          </v-row>
      </div>
    </div>
</template>

<script>
import TUploadPicture from '../../../components/TUploadPictureV2'
export default {
  components: {
    TUploadPicture
  },
  props: {
    orderCode: {
      type: String,
      default: ''
    },
    hasUploadIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      list: [],
      waitPicture: false
    }
  },
  computed: {
  },
  mounted() {
    this.getPictureList()
  },
  created() {
  },
  methods: {
    getPictureList() {
      var that = this
      that.$api.bz.getAppendPicture({ order_code: that.orderCode }).then(res => {
        // console.log('res', res);
        if (!res.success) {
          that.$toast.warning(res.error_msg);
          return
        }
        that.list = res.data
      });
    },
    uploadAppendComp(p) {
      var that = this
      var pid = p.GZ_PICTURE_ID
      that.$api.bz.setAppendPicture({ order_code: that.orderCode, pid: pid }).then(res => {
        if (!res.success) {
          that.$toast.warning(res.error_msg);
          return
        }
        // p.GZ_ORDER_CODE = that.orderCode
        // if (that.list.length === 0) {
        //   var litem = {
        //     gdate: that.$moment(new Date()).format('YYYY-MM-DD'),
        //     plist: [p]
        //   }
        //   that.list.push(litem)
        // } else {
        //   var lastItem = that.list[that.list.length - 1];
        //   lastItem.plist.push(p)
        // }
        that.getPictureList()
      });
    },
    waitState(v) {
      var that = this
      if (!v) {
        that.waitPicture = false
        return
      }
      that.waitPicture = v
    },
    getMsgTimeFormat(time) {
      var that = this
      time = time + ' 00:00:00'
      var tv = that.$moment(time).format('YYYY-MM-DD')
      var now = that.$moment(new Date()).format('YYYY-MM-DD')
      if (tv === now) {
        return '今天'
      }
      if (tv < now) {
        var zt = that.$moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        if (zt === tv) {
          return '昨天'
        }
        var qt = that.$moment(new Date()).add(-2, 'days').format('YYYY-MM-DD')
        if (qt === tv) {
          return '前天'
        }
        return that.$moment(time).format('YYYY年MM月DD日')
      }
      return that.$moment(time).format('HH:mm')
    }
  }
}
</script>

<style scoped>
</style>
